import ContentWrapper from '@mediashop/base/pattern/atom/ContentWrapper';
import CroppedImage from '@mediashop/base/pattern/atom/CroppedImage';
import { Price } from '@mediashop/base/pattern/molecule/Price';
import { CroppedImageVariant } from '@mediashop/base/types/imageVariants';
import classNames from 'classnames';
import { useEffect, useState } from 'react';
import BuyButton from '../../BuyButton';
import { StickyAddToCartBannerProps } from './index';
import { useCheaperSet } from '@mediashop/app/hooks/useCheaperSet';

const componentName = 'sticky-add-to-cart-banner';

const StickyAddToCartBanner = ({
    variant,
    variantImage,
    product,
    handleAddToCartClick,
    isInProgress,
    dontShowPreCheckoutFlyout,
    productRelationType,
    addToCartErrorMessage,
}: StickyAddToCartBannerProps): JSX.Element | null => {
    const [showButton, setShowButton] = useState(false);
    const { cheaperSetPrice, showCheaperSetPrice } = useCheaperSet(variant);

    useEffect(() => {
        const handleScroll = () => {
            const pdpBuyButton = document.querySelectorAll('.product-details-content__buy-button')[0];
            setShowButton(pdpBuyButton && pdpBuyButton.getBoundingClientRect().bottom <= 0);
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <div
            className={classNames(componentName, {
                [`${componentName}--active`]: showButton,
            })}
        >
            <ContentWrapper>
                <div className={`${componentName}__wrapper`}>
                    <div className={`${componentName}__image`}>
                        <CroppedImage
                            altText={variant.attributes.name}
                            src={variantImage.sources[0]?.uri}
                            variant={CroppedImageVariant.PDPThumbnail}
                            fetchPriority="low"
                        />
                    </div>
                    <div className={`${componentName}__content`}>
                        <div className={`${componentName}__title-wrapper`}>
                            <div className={`${componentName}__title`}>{variant.attributes.name}</div>
                        </div>
                        <div
                            className={classNames(`${componentName}__price`, {
                                [`${componentName}__price--sale`]: showCheaperSetPrice,
                            })}
                        >
                            <Price price={showCheaperSetPrice && cheaperSetPrice ? cheaperSetPrice : variant.price} />
                        </div>
                    </div>
                    <div className={`${componentName}__button-wrapper`}>
                        <BuyButton
                            className={`${componentName}__buy-button`}
                            maxQuantity={variant.attributes.maxOrderQuantity}
                            onClick={handleAddToCartClick}
                            isLoading={isInProgress}
                            iconName="none"
                            textId="product.addToCart"
                            goToCart={false}
                            product={product}
                            activeVariant={variant}
                            showMobileIcon={false}
                            hidePreCheckoutFlyout={isInProgress || dontShowPreCheckoutFlyout}
                            productRelationType={productRelationType}
                            addToCartErrorMessage={addToCartErrorMessage}
                            showSelect={false}
                        />
                    </div>
                </div>
            </ContentWrapper>
        </div>
    );
};

export default StickyAddToCartBanner;
